import React, {useState} from 'react';
import FollowupsInfo from './FollowupsInfo';
import FollowupsTicketInfo from './FollowupsTicketInfo';
import { Alert } from 'react-bootstrap';

const FollowupsDetails = () => {
    const [ticket, setTicket] = useState({"ticketFound": "false", "comments": ""});
    const [lastAction, setLastAction] = useState(0);
    const [alertDisplay, setAlertDisplay] = useState(false);
    const [followupAlert, setFollowupAlert] = useState(false);
    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");

    return (
        <div className="main-content">
            <div className='container-fluid'>
                {followupAlert ? (
                    <Alert variant="success" onClose={() => setFollowupAlert(false)} dismissible>
                        <strong>Follow-up sent</strong>
                    </Alert>
                ):(
                    <></>
                )}
                {alertDisplay ? (
                    <Alert variant="danger" onClose={() => setAlertDisplay(false)} dismissible>
                        <strong>Ticket not found</strong>
                    </Alert>
                ):(
                    <></>
                )}
                <div className='row'>
                    <div className='col-md-2'>
                        <FollowupsInfo
                            ticket={ticket}
                            setTicket={setTicket}
                            setLastAction={setLastAction}
                            setAlertDisplay={setAlertDisplay}
                            setFollowupAlert={setFollowupAlert}
                        />
                    </div>
                    <div className='col-md-10'>
                        <FollowupsTicketInfo
                            ticket={ticket}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FollowupsDetails;
